import { listenerMiddleware } from 'legacy/lut/store/middlewares/listenerMiddleware'

import { requestPartnerData } from '../api/requestPartnerData'
import {
  partnerDataFulfilled,
  partnerDataPending,
  partnerDataRejected,
} from '../partnerDataLifecycle'

listenerMiddleware.startListening({
  actionCreator: requestPartnerData.pending,
  effect: (_, { dispatch }) => {
    dispatch(partnerDataPending())
  },
})

listenerMiddleware.startListening({
  actionCreator: requestPartnerData.rejected,
  effect: (action, { dispatch }) => {
    dispatch(partnerDataRejected(action.error.message))
  },
})

listenerMiddleware.startListening({
  actionCreator: requestPartnerData.fulfilled,
  effect: (action, { dispatch }) => {
    dispatch(partnerDataFulfilled(action.payload))
  },
})
